import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from '@app/@core/auth/authentication.service';

@Component({
  selector: 'app-condiciones',
  templateUrl: './condiciones.component.html',
  styleUrls: ['./condiciones.component.scss'],
})
export class CondicionesComponent implements OnInit {
  checked: boolean = false;
  nameLogged: string = '';

  constructor(
    private dialogRef: MatDialogRef<CondicionesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authenticationService: AuthenticationService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {}

  aceptarCondiciones() {
    console.log('Se ha dado a continuar');
    this.dialogRef.close(true);
  }
}
